module.exports = __webpack_public_path__ + "static/media/helpcard_install.4fe8a11d.svg";